<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const emit = defineEmits(["open-legal"]);
</script>

<template>
  <footer class="tb-footer">
    <button
      class="tb-footer-link"
      data-legal="impressum"
      @click="emit('open-legal', 'impressum')"
    >
      {{ t("footer.impressum") }}
    </button>
    <span class="tb-footer-sep">|</span>
    <button class="tb-footer-link" data-legal="tos" @click="emit('open-legal', 'tos')">
      {{ t("footer.tos") }}
    </button>
  </footer>
</template>

<style scoped>
.tb-footer {
  text-align: center;
  padding: 1rem 0 0.5rem;
  font-size: 0.8rem;
  color: #888;
}
.tb-footer-link {
  background: none;
  border: none;
  padding: 0;
  color: inherit;
  cursor: pointer;
  font-size: inherit;
}
.tb-footer-link:hover {
  text-decoration: underline;
  color: #555;
}
.tb-footer-sep {
  margin: 0 0.4rem;
}
</style>
